import type { DonationCampaign } from "./types";
import { isCampaignOngoingStatus } from "./utils";

export const DEFAULT_PRESET_AMOUNTS = [500, 1000, 2500, 5000, 10000];

export function getAggregateStats(campaigns: DonationCampaign[]) {
  const withGoals = campaigns.filter(c => c.goal > 0);
  const totalRaised = withGoals.reduce((sum, c) => sum + c.raised, 0);
  const totalGoal = withGoals.reduce((sum, c) => sum + c.goal, 0);
  const activeDrives = campaigns.filter(
    c => isCampaignOngoingStatus(c.dateStatus) && c.goal > 0
  ).length;
  return { totalRaised, totalGoal, activeDrives };
}
